export const SET_AUTH_USER_DATA = 'SET_AUTH_USER_DATA';
export const DECREMENT_FAVORITES_COUNT = 'DECREMENT_FAVORITES_COUNT';
export const INCREMENT_CART_COUNT = 'INCREMENT_CART_COUNT';
export const DECREMENT_NOTIFICATIONS_COUNT = 'DECREMENT_NOTIFICATIONS_COUNT';
export const DECREMENT_COMMENTS_COUNT = 'DECREMENT_COMMENTS_COUNT';

export const INCREMENT_APHORISMS_COUNT = 'INCREMENT_APHORISMS_COUNT';
export const DECREMENT_APHORISMS_COUNT = 'DECREMENT_APHORISMS_COUNT';

export const INCREMENT_PLAYLISTS_COUNT = 'INCREMENT_PLAYLISTS_COUNT';
export const DECREMENT_PLAYLISTS_COUNT = 'DECREMENT_PLAYLISTS_COUNT';


